
import React from 'react';

const steps = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Enter Your Salary',
    description:
      'Input your gross annual, monthly, or biweekly salary. Choose your filing status and any pre-tax deductions like 401(k) or HSA contributions.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Select Your Location',
    description:
      'Pick your city and state from 200+ US locations or the UK. Each location has precise federal, state, and local tax rates built in.',
  },
  {
    icon: 'ri-pie-chart-line',
    title: 'See Your Tax Breakdown',
    description:
      'Get an instant, detailed breakdown showing federal tax, state tax, Social Security, Medicare, and your exact take‑home pay amount.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Compare &amp; Optimize',
    description:
      'Compare take‑home pay across different cities and states. Use our tax tips blog to find strategies that maximize your paycheck.',
  },
];

const HowItWorks = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            <strong>How the Salary Tax Calculator Works</strong>
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto">
            Four simple steps to understand exactly where your money goes and how to keep more of it.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, i) => (
            <div key={i} className="relative text-center group">
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[60%] w-[80%] h-px bg-gray-200"></div>
              )}
              <div className="relative z-10 w-20 h-20 flex items-center justify-center bg-gray-50 group-hover:bg-teal-50 border-2 border-gray-200 group-hover:border-teal-300 rounded-2xl mx-auto mb-5 transition-all">
                <i
                  className={`${step.icon} text-2xl text-gray-600 group-hover:text-teal-600 transition-colors`}
                  aria-hidden="true"
                ></i>
                <span className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center bg-gray-900 text-white text-xs font-bold rounded-full">
                  {i + 1}
                </span>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{step.title}</h3>
              <p
                className="text-sm text-gray-500 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: step.description }}
              ></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
